module.exports = __webpack_public_path__ + "img/1.78f952f6.png";